import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import React, { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FetchHook from "../../../../Api/FetchHooks";
import TableComponent from "../../../../Components/TableComponent";
import { formatCurrencyV2, formatDate } from "../../../../utils/helpers";

const UserLoanInstalmentDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [loading, response, request] = FetchHook();

  const fetchData = useCallback(async () => {
    await request({
      url: `instalment_detail?loan_instalment_id='${location.state.id}'`,
    });
  }, [location.state.id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      width: 150,
    },
    {
      field: "loan_instalment_id",
      headerName: "Loan Instalment id",
      width: 150,
    },
    {
      field: "instal_type",
      headerName: "Instalment type",
      width: 150,
    },
    {
      field: "expected_collection_amount",
      headerName: "Expected collection amount",
      width: 150,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "actual_paid_amount",
      headerName: "Actual paid amount",
      width: 130,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "balance_amount_payable",
      headerName: "Balance amount payable",
      width: 150,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 300,
    },

    {
      field: "date_created",
      headerName: "Date created",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "receipt",
      headerName: "Receipt",
      width: 200,
      renderCell: (row) => (
        <Button
          variant="contained"
          onClick={() =>
            navigate(
              "/dashboard/users/user-profile/loan-instalments/loan-instalment-details/receipt",
              {
                state: row.row,
              },
            )
          }
        >
          Loan Receipt
        </Button>
      ),
    },
  ];

  return (
    <Box
      sx={{
        margin: "20px",
      }}
    >
      <Card>
        <CardHeader
          sx={{
            px: "30px",
          }}
          title={
            <Typography variant="h6">
              Loan instalments Details (instalment_id: {location.state.id})
            </Typography>
          }
          action={
            <Box>
              <Button
                variant="contained"
                color="error"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Box>
          }
        />
        <CardContent>
          {response && response.status === 200 ? (
            <TableComponent
              data={response.data.InstalmentDetail}
              columns={columns}
              loading={loading}
              sortModel={[
                {
                  field: "date_created",
                  sort: "desc",
                },
              ]}
            />
          ) : (
            <Grid>
              <CircularProgress />
            </Grid>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserLoanInstalmentDetails;
